import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { EconHelpComponent, EconHelpDialogContent } from './econ-help.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';




@NgModule({
  declarations: [EconHelpComponent, EconHelpDialogContent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule
  ],
  exports: [EconHelpComponent, EconHelpDialogContent]
})
export class EconHelpModule { }
